export const currencyTypeList = [
  { label: "USD", value: "USD" },
  { label: "INR", value: "INR" },
  { label: "CAD", value: "CAD" },
];
export const projectMilestoneStatusList = [
  { label: 'Not Started', value: 'NOT_STARTED' },
  { label: 'In Progress', value: 'IN_PROGRESS' },
  { label: 'Completed', value: 'COMPLETED' },
  { label: 'Skip', value: 'SKIP' },
];